export const isDevtoolsEnabled = (): boolean => {
  if (typeof window === 'undefined') return false
  return process.env.NEXT_PUBLIC_STORE_DEBUG === 'true'
}
